import React from 'react';
import BackButton from "../../../../../components/context/FicheContext/Header/BackButton";
import FicheContextHeader from "../../../../../components/context/FicheContext/Header";
import FicheContextHeaderNavigation from "../../../../../components/context/FicheContext/Header/Navigation";

const ContextModelHeader = ({context, contextList, back, setCurrentContext}) => {
  const contextPos = contextList.findIndex((c) => c.id === context.id);

  const setNextContext = () => {
    const nextContextPos = (contextPos + 1) % contextList.length;
    setCurrentContext(contextList[nextContextPos]);
  };

  const setPreviousContext = () => {
    const previousContextPos = (contextPos - 1 + contextList.length) % contextList.length;
    setCurrentContext(contextList[previousContextPos]);
  };

  return <FicheContextHeader>
    <BackButton
      back={back}
      title={context.name}
      icon={"/img/icons/context/contextModel/context.svg"}
    />
    <FicheContextHeaderNavigation
      previous={setPreviousContext}
      next={setNextContext}
      currentCount={contextPos}
      totalCount={contextList.length}
    />
  </FicheContextHeader>
}

export default ContextModelHeader